import { ethers } from 'ethers'
import { formatUnits } from 'ethers/lib/utils'
import React, { useState } from 'react'
import Button from '../components/Button'
import Input from '../components/Input'
import Section from '../components/Section'
import { toast } from 'react-hot-toast'
import { decodeLog, isJSON, isValidTxHash } from '../utils'
import Web3 from 'web3'
import { SupportedChains } from '../utils/constants'
function AbiHelper() {
    const [txHash, setTxHash] = useState('')
    const [contractAddress, setContractAddress] = useState('')
    const [data, setData] = useState('')
    const [abi, setAbi] = useState('')

    const [output, setOutput] = useState('')
    const callFunction = async () => {
        if (!txHash || !abi || !contractAddress) {
            toast.error('Please enter data and abi/args')
            return
        }

        let web3: Web3 | undefined = undefined
        if (!web3) {
            try {
                await (window as any).ethereum.enable()
                web3 = new Web3((window as any).ethereum)
            } catch (error: any) {
                toast.error(`You need to connect Wallet. Error: ${error.toString()}`)
                return
            }
        }
        if (!isValidTxHash(txHash)) {
            toast.error('Invalid txHash')
            return
        }
        const chainId = await web3.eth.getChainId()
        if (!chainId) {
            toast.error('Can not detect chain id')
            return
        }
        if (!SupportedChains[chainId.toString()]) {
            toast.error(`Chain id ${chainId} was not supported`)
            return
        }
        const transaction = await web3.eth.getTransactionReceipt(txHash)
        const logDecrypt = decodeLog(
            transaction.logs.filter(
                (o) => o.address?.toLocaleLowerCase() === contractAddress.toLocaleLowerCase()
            ),
            JSON.parse(abi)
        )
        setOutput(JSON.stringify(logDecrypt))
    }

    const decodeData = async () => {
        if (!data || !abi) {
            toast.error('Please enter data and abi/args')
            return
        }
        let web3: Web3 = new Web3()
        const decoded = web3.eth.abi.decodeParameters([abi], data)
        setOutput(JSON.stringify(decoded))
    }

    return (
        <>
            <div className="container">
                <div className="input-field parse-input">
                    <Input
                        className="method-input__value"
                        onChange={(e) => {
                            setTxHash(e.target.value)
                        }}
                        value={txHash}
                        placeholder="Txhash to decode"
                        type="text"
                        name="data"
                    />
                </div>

                <div className="input-field parse-input">
                    <Input
                        className="method-input__value"
                        onChange={(e) => {
                            setContractAddress(e.target.value)
                        }}
                        value={contractAddress}
                        placeholder="Contract address"
                        type="text"
                        name="topic"
                    />
                </div>
                <div className="input-field parse-input">
                    <Input
                        className="method-input__value"
                        onChange={(e) => {
                            setData(e.target.value)
                        }}
                        value={data}
                        placeholder="Data to decode"
                        type="text"
                        name="data"
                    />
                </div>
                <div className="section encoded-section">
                    <textarea
                        className="method-input__value"
                        placeholder="Abi (JSON array)/Args Type (Add the value types, each seperated by a comma)"
                        rows={20}
                        cols={40}
                        autoComplete="off"
                        onChange={(e) => {
                            setAbi(e.target.value)
                        }}
                        value={abi}
                    />
                </div>

                <div className="section-choose__buttons">
                    <Button className="add-param" onClick={callFunction}>
                        Call
                    </Button>
                    <Button className="add-param" onClick={decodeData}>
                        Decode
                    </Button>
                </div>
                <Section className="encoded-section">
                    <textarea
                        readOnly
                        placeholder="Output"
                        rows={20}
                        cols={40}
                        autoComplete="off"
                        value={output}
                    />
                </Section>
            </div>
        </>
    )
}

export default AbiHelper
